import { useState } from "react"
import { Button } from "src/@/components/ui/button"
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "src/@/components/ui/dialog"
import { Input } from "src/@/components/ui/input"
import { Switch } from "src/@/components/ui/switch"
import { Textarea } from "src/@/components/ui/textarea"
import { RowInput } from "src/components/forms/RowInput"

export default function ModalServicos({
    open,
    onClose,
    onSubmit,
    onEdit,
    isEdit,
    dataService,
    changeName,
    changeDescription,
    changeTime,
    changePrice,
    changePriceSale,
    changeSale,
    changeInstructions
}) {

    return (
        <Dialog open={open} onOpenChange={onClose}>

            <DialogContent className="sm:max-w-[800px]">
                <DialogHeader>
                    <DialogTitle>
                        {!isEdit ? "Criar serviço" : "Editar serviço"}
                    </DialogTitle>

                </DialogHeader>
                <div className="grid gap-4 py-4">
                    <RowInput
                        label="Nome"
                        input={<Input
                            isRequired
                            onChange={changeName}
                            value={dataService?.name}
                        />}
                    />
                    <RowInput
                        label="Descrição do serviços"
                        input={<Textarea
                            isRequired
                            onChange={changeDescription}
                            value={dataService?.description}
                            rows={4}
                        />}
                    />

                    <div className="flex flex-row gap-2 items-center">
                    <div className="w-[150px]">
                            <RowInput
                                label="Tempo do serviço (min)"
                                input={<Input
                                    onChange={changeTime}
                                    isRequired
                                    type="number"
                                    min={30}
                                    value={dataService?.time}

                                />}
                            />
                        </div>
                        <div className="w-[150px]">
                            <RowInput
                                label="Preço"
                                input={<Input
                                    onChange={changePrice}
                                    value={dataService?.price}
                                />}
                            />
                        </div>
                        <div className="w-[150px]">
                            <RowInput
                                label="Preço promocional"
                                input={<Input
                                    onChange={changePriceSale}
                                    value={dataService?.priceSale}
                                />}
                            />
                        </div>
                        <RowInput
                            label="Promoção"
                            input={<Switch
                                checked={dataService?.sale}
                                onCheckedChange={changeSale}
                            />}
                        />

                    </div>
                    <RowInput
                        label="Instrução"
                        input={<Textarea
                            isRequired={true}
                            onChange={changeInstructions}
                            value={dataService?.instructions}
                            rows={4}
                        />}
                    />
                </div>
                <DialogFooter>
                    <Button onClick={ !isEdit ? onSubmit : onEdit}>{!isEdit ? "Criar" : "Salvar"}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
